// A switch, for the settings screen's report-recipient and unsubscribe rows.
//
// No Control/Toggle is drawn in the Figma file, so the geometry here is
// composed from chassis tokens rather than ported — flagged for the /crg-ui
// run. What is NOT negotiable is the semantics: a native <button> carrying
// role="switch" and aria-checked, so it is keyboard operable and announced
// as a switch. A styled <div> with an onClick would look identical and be
// unusable without a mouse.

import "./ui.css";

export type ToggleProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  /** Hide the visible label but keep it as the accessible name. */
  labelHidden?: boolean;
  disabled?: boolean;
};

export function Toggle({
  checked,
  onChange,
  label,
  labelHidden = false,
  disabled = false,
}: ToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={labelHidden ? label : undefined}
      disabled={disabled}
      className="maisight-ui-toggle type-body"
      onClick={() => onChange(!checked)}
    >
      <span className="maisight-ui-toggle-track">
        <span className="maisight-ui-toggle-thumb" />
      </span>
      {labelHidden ? null : <span>{label}</span>}
    </button>
  );
}
